/**
 * lib/cta.ts
 * Costanti per Call-to-Action e testi link consistenti
 */

export const CTA = {
  sagraDetail: "Scopri la sagra",
  backProvincia: (provincia: string) => `Tutte le sagre a ${provincia}`,
  backRegione: (regione: string) => `Sagre in ${regione}`,
} as const;
